// extracted by mini-css-extract-plugin
module.exports = {"checkout":"Checkout_checkout__1IFe1","checkout__left":"Checkout_checkout__left__2czDB","checkout__right":"Checkout_checkout__right__2jUam"};